import { getItem, setItem } from "owa-local-storage";

/**
 * localStorage hint for the MyOutlook Today schedule grid's visibility.
 *
 * The grid is collapsed by default, but once a user makes an explicit choice
 * (the calendar-icon show toggle or the in-grid 'Hide' button) we remember it
 * so the page reopens in their last known state rather than always collapsed.
 * Only explicit show/hides are persisted — the transient detail-pane
 * snapshot/restore never touches this hint.
 */

const SCHEDULE_VISIBLE_KEY = "owa-personal-os-schedule-visible";

/**
 * Reads the persisted schedule-visibility preference. Returns `false` (the
 * collapsed default) when no explicit choice has been recorded yet.
 */
export function getStoredScheduleVisible(): boolean {
    return getItem(self, SCHEDULE_VISIBLE_KEY) === "true";
}

/**
 * Records the user's explicit schedule show/hide so the next page visit
 * defaults to this state.
 */
export function setStoredScheduleVisible(visible: boolean): void {
    setItem(self, SCHEDULE_VISIBLE_KEY, visible ? "true" : "false");
}
